import { connect } from 'react-redux';
import { selectorsResponsive as inboxSelectors } from '../../../../../store/conversations';
import * as userSelectors from '../../../../../../core/selectors/user';
import GroupAvatarIndicator from './GroupAvatarIndicator';

const mapStateToProps = (state) => {
  const conversationId = inboxSelectors.currentConversationId(state);
  const conversation = inboxSelectors.conversation(state, conversationId);
  const currentUser = userSelectors.currentUser(state);

  return {
    conversation,
    currentUser,
  };
};

const mapDispatchToProps = (dispatch) => ({
  openViewParticipants: () => {
    dispatch({ type: 'INBOX_OPEN_VIEW_PARTICIPANTS' });
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GroupAvatarIndicator);
